<script setup>
import {computed} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useUserStore} from '@/stores/user'
import {useFormStore} from '@/stores/form'
import Button from '@/common/Button.vue'

const props = defineProps({
    formId: {
        type: String,
        required: true
    }
})

const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// --- Computed ---

const tableName = computed(() => formStore.value?.tableName)

const id = computed(() => formStore.value?.id ?? 0)

const isSiteTree = computed(() => route.name === 'siteTree')

const addAccess = computed(() => {
    if (tableName.value) {
        return userStore.access(tableName.value, 'add')
    }
})

const isEnabled = computed(() => {
    const disabledTables = ['product_options', 'product_variables', 'account_settings']

    if (disabledTables.includes(tableName.value)) {
        return false
    }

    return addAccess.value
})

// --- Methods ---

const onClick = () => {
    if (isSiteTree.value) {
        // The + button should always show the Add Page form, whether content or a page is selected.
        router.push({
            name: 'siteTree',
            params: {pageOrContentId: '0'}
        })
    } else {
        router.push({
            name: 'form',
            params: {
                component: tableName.value,
                id: 0
            }
        })
    }
}
</script>

<template>
    <Button v-if="isEnabled" :disabled="id === 0" class="rounded-0" @click="onClick">
        <i class="bi-plus-lg"/>
    </Button>
</template>